import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface UseExportTagsMutationOptions {
	onSuccess?: (systemJob: Api.ISystemJob) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	/**
	 * This api endpoint currently does not support impersonation, so we are not passing in the impersonationContext.
	 * This is kept here for backwards compatibility, but will be removed in the future, and it has no effect on the mutation
	 */
	impersonationContext?: Api.IImpersonationContext;
}

/**
 * This api endpoint currently does not support impersonation, so we are not passing in the impersonationContext.
 *
 * Passing it will cause a 404 on the response, which would bring a modal with "Cannot parse response"
 *
 * @param param.onSuccess [optional] Callback function to be called when the mutation is successful.
 * @param param.onError [optional] Callback function to be called when the mutation fails.
 * @param param.impersonationContext [DEPRECATED][optional] The impersonation context to be used for the mutation.
 * @returns
 */
export function useExportTagsMutation({ onSuccess, onError }: UseExportTagsMutationOptions) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async () => {
			return userSession.webServiceHelper.callAsync<Api.ISystemJob>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'tag/export',
				}),
				'POST'
			);
		},
		onSuccess,
		onError,
	});
}
